import axios from 'axios';
import { Message } from "element-ui"
// import Store from "@/store/index"
// 封装服务器地址
axios.defaults.baseURL = 'http://admin.heqitong.cn';

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});


// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // console.log(response, "<<<<<<<返回参数")
    let { data } = response

    // 错误代码
    if (response.config.url == "/api/open/getJsonExact") {
        return response
    }
    if (response.config.url == "/api/user/index") {
        return response
    }
    if (typeof data.code == 'number' && data.code != 1) {
        // console.log(data.code, "<<<<<<<返回参数")
        if (data.code == 3) {
            // location.href = "/#/login"
        } else {
            Message({
                type: "error",
                message: data.msg
            })
        }
        return new Promise(() => { })
    } else if (data.success == false) {
        Message({
            type: "error",
            message: data.msg
        })
        return new Promise(() => { })
    }
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

// 暴露axios
export default axios